import React, { Component } from 'react';
import axios from 'axios';

// REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from 'redux/actions/main';
import * as modalActions from 'redux/actions/modal';

import { getAllUrlParam } from '../../helper';

const ACCEPTED_PARAMS_TOKEN = ['access_token', 'gop_access_token', 'encodeparam', 'code', 'eat'];

class Auth extends Component {
    async componentDidMount() {
        const param = getAllUrlParam();
		const isAcceptedParam = ACCEPTED_PARAMS_TOKEN.some((key) => Object.keys(param).includes(key));

        let token;

        // Fetch token from API if param is accepted
        if (isAcceptedParam) {
            token = await this.props.mainActions.get_jwt_token(param)
        }

        // Backdoor token directly from param if available
        if (param.jwt_token) {
            token = param.jwt_token;
        }
        
        if (token) {
            window.localStorage.setItem('token', token);
            window.localStorage.setItem('param', JSON.stringify(param));

            axios.defaults.headers[process.env.REACT_APP_TOKEN_HEADER_NAME] = token;

            await this.props.mainActions.login();

            this.props.history.push({
                pathname : '/main',
                state : { auth: true }
            });
        } else {
            this.props.history.push({
                pathname : '/main',
                state : { auth : false }
            });
        }
    }

    render() {
        return <div />
    }
}

function mapStateToProps(state) {
    return {
        main : state.main
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mainActions : bindActionCreators(mainActions, dispatch),
        modalActions : bindActionCreators(modalActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
